import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { isTaskOwner, PageLayoutComponent, UserState } from '@shs-digi-care-monorepo/frontend-lib';
import { IUser } from '@shs-digi-care-monorepo/interfaces';
import { select } from '@ngxs/store';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    imports: [RouterModule, TranslateModule, PageLayoutComponent],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MenuComponent {
    protected me: Signal<IUser | null> = select(UserState.me);
    protected isTaskOwner = computed(() => isTaskOwner(this.me()));
}
